import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var SvgPlugOutlined = function SvgPlugOutlined(_a) {
  var _b = _a,
      size = _b.size,
      _b$title = _b.title,
      title = _b$title === void 0 ? "PlugOutlined" : _b$title,
      props = __objRest(_b, ["size", "title"]);

  return (
    /* @__PURE__ */
    React.createElement("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      "data-icon-name": title,
      "aria-label": title,
      role: "presentation"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "currentColor",
      d: "M16.933 4.821a.75.75 0 000 1.5v-1.5zM22 6.321a.75.75 0 000-1.5v1.5zM16.933 3h.75a.75.75 0 00-.75-.75V3zm0 5.143v.75a.75.75 0 00.75-.75h-.75zM8.067 20.25a.75.75 0 000 1.5v-1.5zm8.866-13.929H22v-1.5h-5.067v1.5zM11.867 3.75h5.066v-1.5h-5.066v1.5zM16.183 3v5.143h1.5V3h-1.5zm.75 4.393h-5.066v1.5h5.066v-1.5zm-5.066 0c-.975 0-1.784-.805-1.784-1.822h-1.5c0 1.824 1.46 3.322 3.284 3.322v-1.5zM10.083 5.57c0-1.016.81-1.821 1.784-1.821v-1.5c-1.824 0-3.284 1.498-3.284 3.321h1.5zM8.067 21.75H18.2v-1.5H8.067v1.5zm10.133 0c2.523 0 4.55-2.073 4.55-4.607h-1.5c0 1.726-1.376 3.107-3.05 3.107v1.5zm4.55-4.607c0-2.534-2.027-4.607-4.55-4.607v1.5c1.674 0 3.05 1.38 3.05 3.107h1.5zm-4.55-4.607H6.8v1.5h11.4v-1.5zm-11.4 0c-1.674 0-3.05-1.38-3.05-3.107h-1.5c0 2.533 2.027 4.607 4.55 4.607v-1.5zM3.75 9.429c0-1.727 1.376-3.108 3.05-3.108v-1.5c-2.523 0-4.55 2.074-4.55 4.608h1.5zM6.8 6.32h2.533v-1.5H6.8v1.5z"
    }))
  );
};

var PlugOutlined = withIcon(SvgPlugOutlined);
export { PlugOutlined as default };